﻿/* 
Object:         Enum Module 
Used in:        Every Module 
*/

window.webService_ObjectTypeEnum = {};

Object.defineProperties(window.webService_ObjectTypeEnum, {
    Import_AED_Alert                              : { value: 1, writable: false },
    Import_AG5                                    : { value: 2, writable: false },
    Export_2WAY                                   : { value: 3, writable: false },
    Export_Alarm_Reporting                        : { value: 4, writable: false },
    Export_Occupancy_Reporting                    : { value: 5, writable: false },
    Export_Occupancy_Reportingv2                  : { value: 6, writable: false },
    Incomming_GMS_Incident_aansluiting            : { value: 7, writable: false },
    Outgoing_GMS_Incident_aansluiting_V5          : { value: 8, writable: false },
    Outgoing_WordPress_narrowcast                 : { value: 9, writable: false },    
    Outgoing_2Way_Acknowledge_message             : { value: 10, writable: false },
    Outgoing_2Way_Acknowledge_attendance          : { value: 11, writable: false },
    Outgoing_2Way_Report_location                 : { value: 12, writable: false },
    Outgoing_GMS_VerbindingStatusRequest_V5       : { value: 13, writable: false },
    Outgoing_GMS_IncidentSynchronisatieRequest_V5 : { value: 14, writable: false },
    Outgoing_GMS_Incident_aansluiting_V6          : { value: 15, writable: false },
    Outgoing_GMS_VerbindingStatusRequest_V6       : { value: 16, writable: false },
    Outgoing_GMS_IncidentSynchronisatieRequest_V6 : { value: 17, writable: false },
    Outgoing_GMS_Incident_aansluiting_V7          : { value: 18, writable: false },
    Outgoing_GMS_VerbindingStatusRequest_V7       : { value: 19, writable: false },
    Outgoing_GMS_IncidentSynchronisatieRequest_V7 : { value: 20, writable: false },
    Outgoing_GMS_Incident_aansluiting_V8          : { value: 21, writable: false },
    Outgoing_GMS_VerbindingStatusRequest_V8       : { value: 22, writable: false },
    Outgoing_GMS_IncidentSynchronisatieRequest_V8 : { value: 23, writable: false }
});

Object.freeze(window.webService_ObjectTypeEnum);